"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DefineComponentException extends Error {
    constructor() {
        super(`Il primo argomento del metodo 'define' deve essere una stringa (il nome del nuovo componente).`);
    }
}
exports.DefineComponentException = DefineComponentException;
class ComponentNotFoundException extends Error {
    constructor(name) {
        super(`Il componente '${name}' non è stato trovato.`);
    }
}
exports.ComponentNotFoundException = ComponentNotFoundException;
//# sourceMappingURL=PupsExceptions.js.map